<template>
  <div :class="{ collapsed, medical: !isDentalClinic }">
    <TariffEndsHeader/>
    <PasswordExpiresHeader/>
    <OpenedVisitHeaders/>
    <Sidebar/>
    <div class="sidebar-offset" :class="{ collapsed, rightPaneOpened }">
      <AppHeader/>
      <main :class="mainClass">
        <div class="dentist-container">
          <slot/>
        </div>
      </main>
    </div>
    <div class="mobile-shadow" @click="$store.commit('toggleCollapsed')"></div>
    <FormModal v-if="showModal"/>
    <HappyBirthdayModal v-if="rights.includes('birthday')"/>
    <WebPush/>
    <LaravelEcho/>
    <ModuleNotInTariffModal/>
    <JetAPIChatFrame/>
    <GreenAPIChatFrame/>
    <AuraChatFrame/>
    <Popup/>
    <FillDemoAccount/>
    <DiagnocatMultiUploadModal/>
    <ReasonPrompt ref="reasonPrompt"/>
  </div>
</template>

<script setup>
import Sidebar from "./Sidebar"
import AppHeader from "./AppHeader"
import FormModal from "@/components/parts/datatable/FormModal"
import HappyBirthdayModal from "@/components/parts/patients/HappyBirthdayModal"
import WebPush from "@/components/parts/general/WebPush"
import LaravelEcho from "@/components/parts/general/LaravelEcho"
import ModuleNotInTariffModal from "@/components/parts/billing/ModuleNotInTariffModal"
import TariffEndsHeader from "@/components/parts/general/TariffEndsHeader"
import PasswordExpiresHeader from "@/components/parts/general/PasswordExpiresHeader"
import Popup from "@/components/parts/general/Popup"
import OpenedVisitHeaders from "@/components/parts/patients/visit/OpenedVisitHeaders.vue"
import JetAPIChatFrame from "@/components/parts/crm/JetAPIChatFrame.vue"
import GreenAPIChatFrame from "@/components/parts/crm/GreenAPIChatFrame.vue"
import AuraChatFrame from "@/components/parts/crm/AuraChatFrame.vue"
import FillDemoAccount from "@/components/parts/settings/FillDemoAccount.vue"
import {launchHelpDeskeddy} from "@/services/helpDeskeddy.helper"
import DiagnocatMultiUploadModal from "@/components/parts/patients/DiagnocatMultiUploadModal.vue"
import ReasonPrompt from "@/components/parts/general/ReasonPrompt.vue"
import { setMetrikaUserParams } from "@/services/metrika"
import { computed, onMounted, provide, ref } from "vue"
import { useStore } from "vuex"
import { useRoute } from "vue-router"

const store = useStore()
const route = useRoute()

const experrtoEnabled = false
const reasonPrompt = ref(null)

const collapsed = computed(() => store.state.dom.sidebarCollapsed)
const showModal = computed(() => store.state.datatable.showModal)
const rights = computed(() => store.state.auth.rights)
const user = computed(() => store.state.auth.user)
const clinic = computed(() => store.state.auth.clinic)
const rightPaneOpened = computed(() => store.state.dom.rightPaneOpened)
const isDentalClinic = computed(() => store.getters.isDentalClinic)
// the page can be styled by its route
const mainClass = computed(() => `main-${route?.name || ''}`)

// the pages ask for a reason (e.g. of a cancelled visit) through the prompt of the layout
provide('showReasonPrompt', () => reasonPrompt.value.showPrompt())

onMounted(() => {
  if(user.value && user.value.id) {
    let params = { UserID: user.value.id }
    if(clinic.value) params.ClinicID = clinic.value.id
    setMetrikaUserParams(params)
  }

  if(clinic.value && clinic.value.support_button === 1) {
    // (function (w, d, u) {
    //
    //   var s = d.createElement('script');
    //   s.async = true;
    //   s.src = u + '?' + (Date.now() / 60000 | 0);
    //   var h = d.getElementsByTagName('script')[0];
    //   h.parentNode.insertBefore(s, h);
    // })(window, document, 'https://cdn-ru.bitrix24.ru/b15023132/crm/site_button/loader_6_y945vk.js');
    launchHelpDeskeddy()
  }

  if(experrtoEnabled && user.value && user.value.role_id == 2) {
    let externalScript = document.createElement('script')
    externalScript.setAttribute('src', 'https://cdn.experrto.io/client/experrto.js')
    document.head.appendChild(externalScript)
    let u = user.value
    externalScript.onload = function() {
      if(window.Experrto) {
        window.Experrto.identify("0092ea9463a637e09cf91be56a88631d0b5dfc6a", {
          userId: u.id
        })
      }
    }
  }

  // logged out in another tab
  window.addEventListener('storage', (e) => {
    if (e.key === 'logout') location.href = '/login'
  })
})
</script>
